import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 32px;

  @media screen and (max-width: 768px) {
    & > div {
      margin-top: 40%;
    }
  }
`;

export const BackButton = styled.button`
  background: none;
  padding: 0px;
  color: #9000ff;
  border: none;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 32px;

  & > svg {
    margin-right: 12px;
    height: 14px;
  }
`;
